<script setup>
import { reactive, ref, onMounted } from "vue";
import { apiQuery } from "@/api/j24api";
import { get } from "aws-amplify/api";

var permissions = reactive([]);
const loading = ref(false);
const search = ref("");
const selectedPermission = ref({});
const deletePermissionConfirm = async (permission) => {
  if (
    confirm(
      `Are you sure you want to delete the permission "${permission.permissionName}" for application "${permission.app}"? This action cannot be undone.`
    )
  ) {
    await deletePermission(permission);
  }
};

async function getPermissions() {
  loading.value = true;
  try {
    const testing = await apiQuery("J24Auth", "getpermission", "");
    //console.log(testing);
    permissions.length = 0;
    permissions.push(...testing);
    //permissions = testing;
  } catch (error) {
    console.log(error);
  }
  loading.value = false;
}

async function deletePermission(permission) {
  permission.deleted = true;
  console.log(permission);
  loading.value = true;
  const result = await apiQuery("J24Auth", "updatepermission", permission);
  getPermissions();
}

const addingNew = ref(false);
var newPermission = reactive({
  permissionName: "",
  app: "",
});

async function addNew() {
  loading.value = true;
  await apiQuery("J24Auth", "addpermission", newPermission);
  getPermissions();
  addingNew.value = false;
}

onMounted(() => {
  getPermissions();
});

const headers = [
  { title: "Application", value: "app", sortable: true },
  { title: "Permission Name", value: "permissionName", sortable: true },
  { title: "Actions", value: "actions", sortable: false },
];
</script>

<template>
  <div v-if="addingNew">
    <h1>Add New Permission</h1>
    <v-form>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              density="compact"
              v-model="newPermission.app"
              label="Application"
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              density="compact"
              label="Permission Name"
              v-model="newPermission.permissionName"
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col
            ><v-btn :loading="loading" @click="addNew">Add</v-btn>
            <v-btn class="ml-2" @click="addingNew = false">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>

  <template v-else>
    <h1>Permissions</h1>
    <v-row>
      <v-col cols="4"
        ><v-text-field
          v-model="search"
          label="Search..."
          variant="outlined"
        ></v-text-field
      ></v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto"
        ><v-btn @click="addingNew = !addingNew">Add New</v-btn></v-col
      >
    </v-row>

    <v-data-table
      :headers="headers"
      :items="permissions"
      :loading="loading"
      :search="search"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          icon="mdi-delete"
          variant="plain"
          @click="deletePermissionConfirm(item)"
        ></v-btn>
      </template>
    </v-data-table>
    <!-- <div v-if="permissions.length">
    <v-table>
      <thead>
        <tr>
          <th>Application</th>
          <th>Permission Name</th>
          <th>Actions</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="permission in permissions" :key="permission._id">
          <td>{{ permission.app }}</td>
          <td>{{ permission.permissionName }}</td>
          <td>
            <div v-for="item in permission.actions" :key="item">
              {{ item }}<br />
            </div>
          </td>
          <td>
            <v-icon @click="deletePermission(permission)">mdi-delete</v-icon>
          </td>
        </tr>
      </tbody>
    </v-table>
  </div> -->
  </template>
</template>
